angular.module('tct.usersService', ['tct.configService'])
  .factory('usersService', usersService);

usersService.$inject = ['configService', '$http'];

function usersService(config, $http) {
  const basePath = `${config.APP_PROTOCOL}://${config.APP_API}:${config.APP_API_PORT}/api/accounts`;
  const factory = {
    getUsers,
  };

  return factory;

  function getUsers() {
    const url = `${basePath}`;
    return $http.get(url);
  }
}
